import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import Tabs, { TabPane } from 'rc-tabs';
import { uniqBy } from 'lodash';
import { RootState } from '@/models/index';
import CitySelect from '@/components/city-select';
import 'rc-tabs/assets/index.css';
import { provinceData } from '@/utils/city';
import TagList from '@/components/tag-list';
import Button from '@/components/button';
import styles from './index.module.scss';

export default function CitySelectContent({ hotCity = [] }) {
  const dispatch = useDispatch();
  const { filterData } = useSelector<RootState, RootState['brand']>(state => state.brand);
  const [selected, setSelected] = useState(filterData.filter(item => item?.type === 'hot_city'));
  const handleChange = (value, id) => {
    let ids = [];
    if (id) {
      ids = [...selected.filter(item => id.indexOf(item.id) <= -1), ...value];
    } else {
      ids = [...selected, ...value];
    }
    setSelected(uniqBy(ids, 'id'));
  };
  const handleConfirm = () => {
    let filterIds = uniqBy([...filterData, ...selected], 'id');
    filterIds = uniqBy(filterIds, 'name');
    dispatch({ type: 'brand/setFilterData', payload: filterIds.filter(item => +item.id > 0) });
    dispatch({ type: 'brand/setHasOtherCity', payload: filterIds.length > 0 });
    dispatch({ type: 'modal/close' });
  };
  return (
    <div className={styles.citySelect}>
      <div className={classNames('flex-row-nowrap', 'flex-between-center', styles.header)}>
        <div className={styles.title}>城市选择</div>
      </div>
      <Tabs tabPosition="left">
        <TabPane key="1" tab="热门城市">
          <div className={styles.hotCityTag}>
            <div className={styles.hotCityTagTit}>热门城市</div>
            <TagList
              list={hotCity || []}
              onChange={handleChange}
              width={94}
              fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
              defaultValue={filterData.map(item => item.id)}
            ></TagList>
          </div>
        </TabPane>
        <TabPane key="2" tab="全部城市">
          <Tabs tabPosition="left" tabBarGutter={0}>
            {provinceData.map(item => (
              <TabPane key={item.id} tab={item.name}>
                <CitySelect
                  provinceId={item.id}
                  provinceName={item.name}
                  onChange={handleChange}
                  defaultValue={filterData.map(item => item.id)}
                />
              </TabPane>
            ))}
          </Tabs>
        </TabPane>
      </Tabs>
      <div className={styles.confirmBtn}>
        <Button
          width={202}
          height={40}
          type={selected && selected.length > 0 ? 'normal' : 'default'}
          disabled={!selected || selected.length === 0}
          onClick={handleConfirm}
        >
          确认选择
        </Button>
      </div>
    </div>
  );
}
